import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
// import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./recruiterReview.css"
import { faBriefcase, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { Rating } from '@mui/material';
import { apiService } from '../../services/apiService';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
function ReviewRecComponent({ allPreviewData, onReload  }) {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [reviewData, setReviewData] = useState([]);
    const [shortQuery, setShortQuery] = useState("");
    const [ratings, setRatingValue] = useState(0);
    const [errors, setErrors] = useState({});
    const [justification, setComment] = useState('');
    const userId = localStorage.getItem('userid');
    const permissionstest = JSON.parse(localStorage.getItem('permissions'));
    const [editShow, setEditShow] = useState(false);
    const [editId, setEditId] = useState(0);
    // const [editDatas, setEditDatas] = useState({});
    const [ratingsEdit, setRatingValueEdit] = useState(0);
    const [errorsEdit, setErrorsEdit] = useState({});
    const [justificationEdit, setCommentEdit] = useState('');
    
    const fetchReviewData = useCallback(async (params = {}) => {
        try {
        const defaultParams = {user_id: id , ...params };
        const response = await apiService.postRequest(`user-reviews-list`, defaultParams);
        if(response && response.success === true){
            setReviewData(response.data);
        }else{
            setReviewData([]);
            if(response.authenticate === false){
                await apiService.postRequest('/auth/logout');
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/login';
            }
        }
        } catch (error) {
        console.error('Error fetching group data:', error);
        }finally{
        setLoading(false)
        }
    }, [id]);

    const handleShortChange = (shortOption) => {
        setShortQuery(shortOption);
        fetchReviewData({ sort_by: shortOption, user_id: id }); 
    };
    useEffect(() => {
        fetchReviewData();
    }, [fetchReviewData]);
    
    const handleSubmit = async (e) => {
        e.preventDefault(); 
        const newErrors = {};
        if (justification.trim() === '') {
            newErrors.justification = "Please enter a comment.";
        }
        if (ratings === '') {
            newErrors.ratings = "Please enter a Rating.";
        }

        // If there are errors, update the errors state and do not submit
        if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
        }

        try{
            const jsonParams = {
                employee_id: Number(id),
                ratings: Number(ratings),
                justification: justification,
            }
            const response = await apiService.postRequest(`employee-reviews`, jsonParams);
            if(response && response.success === true){
                toast(response.message || "Comment Submitted");
                setComment("");
                setErrors({});
                fetchReviewData();
                if (onReload) onReload();
            }else{
                toast.error(response.message || "Comment Submitted");
                if(response.errors){
                    setErrors(response.errors)
                }
                if(response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
            }catch (error) {
                console.error('Error fetching data:', error);
        }
    };


    const handleEditToggle = (item) => {
        setEditShow(prev => !prev);
        setEditId(item.id);
        setRatingValueEdit(item.ratings);
        setCommentEdit(item.justification);
    };

    const handleSubmitUpdate = async (e) => {
        e.preventDefault();

        try{
            const jsonParams = {
                ratings: Number(ratingsEdit),
                justification: justificationEdit,
            }
            const response = await apiService.putRequest(`employee-reviews/${editId}`, jsonParams);
            if(response && response.success === true){
                toast(response.message || "Comment Updated");
                setComment("");
                setErrorsEdit({});
                fetchReviewData();
                setEditShow(false);
                setEditId(null);
                setRatingValueEdit(0);
                setCommentEdit("");
            }else{
                toast.error(response.message || "Comment Updated");
                if(response.errors){
                    setErrorsEdit(response.errors)
                }
                if(response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
            }catch (error) {
                console.error('Error fetching data:', error);
        }
    };

    const sanitizeAndDisplayHTML = (html) => {
        if (!html) return '';

        // Handle both \n and \r\n (Windows/Mac/Linux line endings)
        const formattedHTML = html
            .replace(/(\r\n|\r|\n){2,}/g, '<br><br>') // double line breaks
            .replace(/(\r\n|\r|\n)/g, '<br>');        // single line breaks

        return formattedHTML;
    };
  return (
    <Grid size={{xs:12}} container className="mt-5">
        <Grid size={{xs:12}} container justifyContent="space-between" className="main_shower_viewrecrev">
            {allPreviewData && allPreviewData.profile_picture ? 
                <img className='profile_imges' src={allPreviewData.profile_picture} alt=''/>:
                <img className='profile_imges' src={require("../../assets/defaultprofile.svg").default} alt=''/>
            }
            <Grid container justifyContent="space-between" alignContent="space-between" className="widther_recruitereview">
                <Grid size={{xs:12}} container justifyContent="space-between" className="order_recriview">
                    <h5>{allPreviewData.name}</h5>
                    <div className='d-flex align-items-center gap-3 ratinglabel'>
                        <Rating className='rating_spanhiders' disabled value={allPreviewData.avg_rating} precision={0.5}/>
                        <small className='sml_underline'>{allPreviewData.total_reviews} Reviews</small>
                    </div>
                </Grid>
                <Grid size={{xs:12}} container justifyContent="space-between" className="order_recriview2 gap-4">
                    <span>{allPreviewData.job_title || "No Job Title"}</span>
                    <span><FontAwesomeIcon className='icon_recrev' icon={faPhone} />{allPreviewData.phone_number}</span>
                    <span><FontAwesomeIcon className='icon_recrev' icon={faEnvelope} />{allPreviewData.email}</span>
                    <span><FontAwesomeIcon icon={faBriefcase} className='icon_recrev'/>{allPreviewData.experience_months}</span>
                    {allPreviewData && allPreviewData.linkedin_url &&
                    <span>
                        <a href={`${allPreviewData.linkedin_url}`} target="_blank" rel="noopener noreferrer"><img src={require("../../assets/linkedin-logo-blue.svg").default} alt=''/></a>
                    </span>}
                </Grid>
            </Grid>
            {allPreviewData && allPreviewData.review_status !== 1 && permissionstest && permissionstest.manage_review_provider === true && userId !== id &&
            <Grid size={{xs:12}} container>
                <Grid size={{xs:12}} container justifyContent="center" className="mt-5">
                    <Grid container size={{xs:12}} alignItems="center" alignContent="center" className="my-md-0 my-2">
                    <span className='raters_helpspan'>Rate this recruiter</span>
                    <Rating 
                        className='rating_spanhiders' 
                        value={Number(ratings)} 
                        onChange={(e) => setRatingValue(e.target.value)}
                    />
                    </Grid>
                    <div className='w-100'>
                        {errors.ratings && <p style={{color:"red"}}>{errors.ratings}</p>}
                    </div>
                </Grid>
                <form className='w-100' onSubmit={handleSubmit}>
                    <Grid size={{sm:12}} container justifyContent="flex-end" className="mt-4">
                        <textarea 
                        className='comment_textarea' 
                        placeholder="Post a comment...." 
                        value={justification} 
                        onChange={(e) => setComment(e.target.value)} 
                        style={{height:"250px"}}
                        />
                        <div className='w-100'>
                            {errors.justification && <p style={{color:"red"}}>{errors.justification}</p>}
                        </div>
                        <button type="submit" className='submit_btn'>Submit</button>
                    </Grid>
                </form>
            </Grid>}
            <Grid size={{ xs: 12 }} container justifyContent="space-between" alignItems="center" className="my-4">
                <Grid size={{ md:4,sm:6,xs: 12 }} container flexDirection="column">
                    <h4 className='mb-0'>Reviews</h4>
                </Grid>
                <Grid size={{ sm:4,xs: 12 }} container alignItems="center" className="gap-3" justifyContent="end">
                    <div className='d-flex my-3 short_byonboard'>
                        <label>Sort by: </label>
                        <select className='ms-2' value={shortQuery} onChange={(e) => handleShortChange(e.target.value)}>
                            <option value="">All</option>
                            <option value="newest">Newest</option>
                            <option value="oldest">Oldest</option>
                            <option value="rating_high">Rating High</option>
                            <option value="rating_low">Rating Low</option>
                        </select>
                    </div>
                </Grid>
            </Grid>
            <Grid size={{xs:12}} container >
                {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                    {reviewData && reviewData.length > 0 ? (
                        reviewData && reviewData.map((datas, index) => ( 
                        <Grid size={{ xs: 12 }} key={index} container>
                            <Grid size={{ xs: 12 }} container alignItems="center" justifyContent="space-between" className="mb-3 reply_comment_btn previous_comments">
                                <div className='d-flex d-flex align-items-center gap-2'>
                                <small style={{whiteSpace: "nowrap"}} className='pink_small w-100'>@{datas.reviewer_name}</small>
                                <Rating className='rating_spanhiders secondarystar_recrev mt-0' disabled value={datas.ratings} />
                                </div>
                                <small className='datetime_small'>
                                    {datas.created_at}
                                </small>
                                <span className='text-break'>
                                    <div className='w-100' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(datas.justification) }} />
                                    {datas && datas.is_edited === true &&
                                        <small className='w-100 mt-2 fw-bold d-flex justify-content-end' style={{color:"#1A5298"}}>(Edited)</small>
                                    }
                                </span>

                                {Number(userId) === datas.reviewer_id && datas.revision_status === true && permissionstest && permissionstest.manage_review_provider === true &&
                                    <button className='reply_btntext' onClick={() => handleEditToggle(datas)}>
                                        {editId === datas.id && editShow === true ? "Cancel" : "Edit"}
                                    </button>
                                }
                            </Grid>
                            {editId === datas.id && editShow === true && permissionstest && permissionstest.manage_review_provider === true && (
                                <Grid size={{xs:12}} container>
                                    <Grid size={{xs:12}} container justifyContent="center">
                                        <Grid container size={{xs:12}} alignItems="center" alignContent="center" className="my-md-0 my-2">
                                        <span className='raters_helpspan'>Rate this recruiter</span>
                                        <Rating 
                                            className='rating_spanhiders' 
                                            value={Number(ratingsEdit)} 
                                            onChange={(e) => setRatingValueEdit(e.target.value)}
                                        />
                                        </Grid>
                                        <div className='w-100'>
                                            {errors.ratings && <p style={{color:"red"}}>{errors.ratings}</p>}
                                        </div>
                                    </Grid>
                                    <form className='w-100' onSubmit={handleSubmitUpdate}>
                                        <Grid size={{sm:12}} container justifyContent="flex-end" className="mt-2">
                                            <textarea 
                                            className='comment_textarea' 
                                            placeholder="Post a comment...." 
                                            value={justificationEdit} 
                                            onChange={(e) => setCommentEdit(e.target.value)} 
                                            style={{height:"250px"}}
                                            />
                                            <div className='w-100'>
                                                {errorsEdit.justification && <p style={{color:"red"}}>{errorsEdit.justification}</p>}
                                            </div>
                                            <button type="submit" className='submit_btn'>Update</button>
                                        </Grid>
                                    </form>
                                </Grid>
                            )}
                        </Grid>
                        ))
                    ) : ( 
                        <div className="w-100 d-flex justify-content-center mt-4">
                            <p>No Reviews</p>
                        </div>
                    )}
                </>}
            </Grid>
        </Grid>
    </Grid>
  )
}

export default ReviewRecComponent
